import { ACADEMIC_SYNC_TYPE, academicMainSyncStatusObject, syncStatus, getMasterSyncStatus } from '@/helpers/contentSync';

export default {
  props: {
    courseContext: {
      type     : [Object, null],
      default  : () => ({}),
      required : true
    },
    hasAbsolutePosition: {
      type    : Boolean,
      default : false
    },
    associatedAcademicMains: {
      type    : Array,
      default : () => []
    },
    hasLocalChanges: {
      type    : Boolean,
      default : false
    }
  },
  data() {
    return {
      academicMainSyncStatusObject,
      syncStatus
    };
  },
  computed: {
    isMaster() {
      return this.courseContext?.academicSyncTypeId === ACADEMIC_SYNC_TYPE.MASTER;
    },
    isAssociated() {
      return this.courseContext?.academicSyncTypeId === ACADEMIC_SYNC_TYPE.ASSOCIATE;
    },
    syncStatusObject() {
      let syncStatusId =  this.courseContext?.syncStatus || syncStatus.NOT_SYNCHRONIZED;
      let tooltipMessage = this.$t('content.academicMainSyncStatus.tooltipText', { academicMainMasterName: this.courseContext?.academicMainMasterName });
      
      if (this.isMaster) {
        const masterVersionAt = this.courseContext?.academicMainAssociatedVersionAt || null;
        const associatedAcademicMains = this.associatedAcademicMains;

        syncStatusId = getMasterSyncStatus({
          masterVersionAt,
          associatedAcademicMains,
          hasLocalChanges: this.hasLocalChanges 
        });

        switch (syncStatusId) {
          case syncStatus.NOT_SYNCHRONIZED:
            tooltipMessage = this.$t('content.academicMainSyncStatus.notSynchronizedMasterTooltip');
            break;
          case syncStatus.WAITING_FOR_SYNC:
            tooltipMessage = this.$t('content.academicMainSyncStatus.waitingForSyncMasterTooltip');
            break;
          case syncStatus.SYNCHRONIZED:
            tooltipMessage = this.$t('content.academicMainSyncStatus.synchronizedMasterTooltip');
            break;
          case syncStatus.ERROR:
            tooltipMessage = this.$t('content.academicMainSyncStatus.errorMasterTooltip');
            break;
          default:
            tooltipMessage = this.$t('content.academicMainSyncStatus.notSynchronizedMasterTooltip');
        }
      }

      return { syncStatusId, tooltipMessage };
    }
  }
};
